module.exports = function(bootstrap) {
    bootstrap.run(["Service","$filter",'sessionData', function (Service,$filter, sessionData) {
        new Service({
                        name: 'cmodDocument',
                        group: "eprsvc",
                        url: "/eprsvc/x-services/secure/documents/v1/CMOD-document",
                        cache: true,
                        fetch: function (document) {
                            var test = [];
                            test = document.split("_");
                            var keytooPas = test[1].match(/.{1,8}/g);
                            var test2split = test[2].split(".");
                            var odFolder = "CHM-HM-3COM-BB-CONTRACT-RIDERS";
                            var userId = "appchm";
                            beginDate = $filter('date')(new Date(new Date().setFullYear(new Date().getFullYear() - 3)),"MM-dd-yyyy");
                            console.log(beginDate);
                            //console.log(date);
                            //var endDate = new Date();
                            endDate=$filter('date')(new Date(),"MM-dd-yyyy");
                            console.log(endDate);
                            var key1 = "C";
                            var key2 = test[0];
                            var key3="";
                            var key4 = keytooPas[1];
                            var key5 = test2split[0];

                            var theParamsEtc ='/' + odFolder +'/'+ beginDate + '/' + endDate + '?key1=' + key1
                                +'&key2=' + key2 + '&key3=' + key3 + '&key4=' + key4+'&key5='+key5;
                            console.log(theParamsEtc);

                            //   return this.post({
                            // "payload": {
                            //   "userId":"appchm",
                            //  "odFolder":"CHM-HM-3COM-BB-CONTRACT-RIDERS",
                            //   "beginDate":"01/09/16",
                            //  "endDate":"01/09/19",
                            //  "key1":"C",
                            //  "key2":test[0],
                            //  "key3":"",
                            // "key4":keytooPas[1],
                            //  "key5":test2split[0],
                            // }

                            //      });
                            this.headers['APPID'] = "EPRWEB",
                                this.headers['clientHost'] = "hmhs.com",
                                this.url = this.url + theParamsEtc;
                            if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                                this.headers['ClientNumber']  = sessionData.clientNumber;
                            }
                            console.log(this.url);

                            return this.get();

                        }
                                     });
    }]);

};

